import axios from "axios";

export default async function VerificaToken() {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      return {
        login: false,
        codcliente: null,
        tipo: "",
      };
    }

    const response = await axios.get(
      "https://app.eliandroalimentos.com.br/api/primeiro_acesso/verificar-token",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const codcliente = String(
      response.data.usuario.codcliente
    );

    const codClienteCarrinho =
      localStorage.getItem("codclienteCarrinho");

    // Se não existir um cliente associado ao carrinho
    // ou se o carrinho pertencer a outro cliente,
    // limpa o carrinho.
    if (
      !codClienteCarrinho ||
      codClienteCarrinho !== codcliente
    ) {
      localStorage.removeItem("carrinho");

      window.dispatchEvent(
        new Event("carrinhoAtualizado")
      );
    }

    // Salva o cliente atual como dono do carrinho
    localStorage.setItem(
      "codclienteCarrinho",
      codcliente
    );

    return {
      login: true,
      codcliente: response.data.usuario.codcliente,
      razaosocial: response.data.usuario.razaosocial,
      tipo: response.data.usuario.tipo,
      limitecrdt: response.data.usuario.limitecrdt,
      representante: response.data.usuario.codrepresentante,
      codplano:response.data.usuario.codplano,
    };
  } catch (error) {
    console.error("Erro ao verificar token:", error);

    return {
      login: false,
      codcliente: null,
      tipo: "",
    };
  }
}